import { AllegatoDtoTipoDocumentoEnum, SoggettoDto } from "@api/client";
import docIdeFront from "assets/images/doc-ide/front.png";
import docIdeRetro from "assets/images/doc-ide/retro.png";
import { fileUpload } from "common/_redux/file/actions";
import { subjectUpdateSubject } from "common/_redux/subject/actions";
import AppDatePicker from "common/components/app-date-picker";
import BftButton from "common/components/button";
import BftDropzone from "common/components/dropzone";
import BftInput from "common/components/input";
import MessageModal from "common/components/message-modal";
import BftSelect from "common/components/select";
import { FilesUtils } from "common/file.utils";
import { Formik, verificaIdentitaSchema } from "common/validators/validators";
import { IdTipoDocumenti, IdTipoDocumentiEstesi, TipoDocumenti } from "constants/global";
import { useAppDispatch } from "core/store/hooks";
import { FileDocument } from "models/files";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

interface FormValues {
	isTesSanVisible: boolean;
	tipoDocumento: string | undefined;
	DOC_IDE_FRONT: FileDocument | undefined;
	DOC_IDE_BACK: FileDocument | undefined;
	DOC_PAT_FRONT: FileDocument | undefined;
	DOC_PAT_BACK: FileDocument | undefined;
	DOC_PAS_FRONT: FileDocument | undefined;
	DOC_PAS_BACK: FileDocument | undefined;
	TES_SAN: FileDocument | undefined;

	numeroDocumento: string | undefined;
	documentoRilasciatoDa: string | undefined;
	dataRilascioDocumento: Date | undefined;
	dataScadenzaDocumento: Date | undefined;
}

const documentiList = [
	{
		key: "",
		value: "",
	},
	{
		key: TipoDocumenti.PATENTE,
		value: "Patente",
	},
	{
		key: TipoDocumenti.CARTA_IDENTITA,
		value: "Carta di identità",
	},
	{
		key: TipoDocumenti.PASSAPORTO,
		value: "Passaporto",
	},
];

const ENTI_RILASCIO_DOCUMENTO: { [key: string]: { [key: string]: string }[] } = {
	[TipoDocumenti.PATENTE]: [
		{ key: "", value: "" },
		{
			key: "MIT-UCO",
			value: "MIT-UCO - Ufficio Centrale Operativo del Ministero",
		},
		{ key: "MC", value: "MC - Motorizzazione Civile" },
		{
			key: "PREFETTURA",
			value: "Prefettura",
		},
	],
	[TipoDocumenti.PASSAPORTO]: [
		{ key: "", value: "" },
		{ key: "QUESTURA", value: "Min. degli Esteri" },
	],
};

const dropzoneIdentifiers = [
	IdTipoDocumenti.CARTA_ID_FRONT,
	IdTipoDocumenti.CARTA_ID_BACK,
	IdTipoDocumenti.PATENTE_FRONT,
	IdTipoDocumenti.PATENTE_BACK,
	IdTipoDocumenti.PASSAPORTO_FRONT,
	IdTipoDocumenti.PASSAPORTO_BACK,
];

interface Props {
	subjectDetails?: SoggettoDto;
	idPratica?: string | undefined;
	idCliente?: string | undefined;
	onComplete: (email?: string) => void;
	isInvitation?: boolean;
	skipSaveStepStatus?: boolean;
}

const VerificaIdentita: React.FC<Props> = (props) => {
	const { subjectDetails, isInvitation = false, skipSaveStepStatus = false, onComplete } = props;
	const [formValues, setFormValues] = useState<any>({});

	const dispatch = useAppDispatch();
	const location = useLocation();

	const [showModal, setShowModal] = useState<boolean>(false);

	const isReopenPath = location.pathname.startsWith("/reopen");
	const isIdentificationPath =
		location.pathname === "/step-3/identificazione-titolare-effettivo/verifica-identita-te";

	const _handleSubmit = (values: FormValues) => {
		const fileGroups = [
			[values.DOC_IDE_FRONT, values.DOC_IDE_BACK],
			[values.DOC_PAS_FRONT, values.DOC_PAS_BACK],
			[values.DOC_PAT_FRONT, values.DOC_PAT_BACK],
		];

		let files = fileGroups
			.map(([front, back]) => [front, back].filter(Boolean))
			.reduce((acc, curr) => acc.concat(curr), []);

		if (values?.TES_SAN) {
			files.push(values?.TES_SAN);
		}

		files = files?.filter((f) => f !== undefined && f?.size > 0);

		let subject: SoggettoDto = {
			...subjectDetails,
			...values,
			fullfiled: true,
		};

		dispatch(fileUpload(files as FileDocument[]))
			.unwrap()
			.then((response) => {
				if (response || files.length < 1) {
					dispatch(
						subjectUpdateSubject({ subject, sendNotification: isInvitation, skipSaveStepStatus })
					)
						.unwrap()
						.then((res) => {
							if (res) {
								setFormValues((prev: SoggettoDto) => {
									return {
										...prev,
										...res,
										DOC_IDE_FRONT: res.elencoAllegati,
										DOC_IDE_BACK: res.elencoAllegati,
										DOC_PAT_FRONT: res.elencoAllegati,
										DOC_PAT_BACK: res.elencoAllegati,
										DOC_PAS_FRONT: res.elencoAllegati,
										DOC_PAS_BACK: res.elencoAllegati,
										TES_SAN: res.elencoAllegati,
									};
								});
								onComplete(subject.email);
							}
						});
				}
			});
	};

	useEffect(() => {
		if (isIdentificationPath && subjectDetails?.tipoSoggetto === "Titolare") {
			setShowModal(true);
		}

		setFormValues({
			isTesSanVisible: !subjectDetails?.idEsponente,
			tipoDocumento: subjectDetails?.tipoDocumento || "",
			DOC_IDE_FRONT: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.CartaIdFront
				)
			),
			DOC_IDE_BACK: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.CartaIdBack
				)
			),
			DOC_PAT_FRONT: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.PatenteFront
				)
			),
			DOC_PAT_BACK: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.PatenteBack
				)
			),
			DOC_PAS_FRONT: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.PassaportoFront
				)
			),
			DOC_PAS_BACK: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.PassaportoBack
				)
			),
			TES_SAN: FilesUtils.AllegatoDtoToFileDocument(
				subjectDetails?.elencoAllegati?.find(
					(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.TesseraSanitaria
				)
			),
			numeroDocumento: subjectDetails?.numeroDocumento || "",
			documentoRilasciatoDa: subjectDetails?.documentoRilasciatoDa || undefined,
			dataRilascioDocumento: subjectDetails?.dataRilascioDocumento || undefined,
			dataScadenzaDocumento: subjectDetails?.dataScadenzaDocumento || undefined,
		});
	}, [subjectDetails]);

	return (
		<>
			<Formik
				initialValues={formValues}
				validationSchema={verificaIdentitaSchema}
				onSubmit={_handleSubmit}
				enableReinitialize
			>
				{(props) => {
					const {
						handleSubmit,
						handleChange,
						setFieldValue,
						setFieldTouched,
						values,
						touched,
						errors,
					} = props;

					const handleFileChange = (name: string, file?: any) => {
						// if (IdTipoDocumenti?.PATENTE_FRONT || IdTipoDocumenti?.PATENTE_BACK) {
						// 	setFieldValue("documentoRilasciatoDa", "Roma");
						// }
						setFieldTouched(name);
						setFieldValue(name, file);
					};

					const handleChangeCustom = (input: string, type?: string) => (e: any) => {
						if (type === "date") {
							setFieldValue(input, e);
							return;
						}
					};

					const clearDropzones = () => {
						for (const identifier of dropzoneIdentifiers) {
							handleFileChange(identifier, undefined);
						}
					};

					console.log(errors);

					return (
						<form noValidate onSubmit={handleSubmit}>
							<div className="container mb-3 text-center">
								<span className="gray m-0 text-decoration-underline h5">
									INSERISCI IL DOCUMENTO DI IDENTITA' DEL <br></br>
									{subjectDetails?.tipoSoggetto === "RappresentanteLegale" ? (
										<b className="text-decoration-underline h5">RAPPRESENTANTE LEGALE</b>
									) : (
										<b className="text-decoration-underline h5">TITOLARE EFFETTIVO</b>
									)}
									<br></br>
								</span>
								<b>E' necessario che la scansione sia nitida e la foto ben visibile.</b>
							</div>

							{!isReopenPath && (
								<Row className="d-flex justify-content-center">
									<Col md={8}>
										<BftSelect
											name={"tipoDocumento"}
											placeholder={"Seleziona il documento*"}
											value={values?.tipoDocumento}
											onChange={(e) => {
												clearDropzones();
												handleChange(e);
											}}
											options={documentiList}
											isInvalid={!!(touched?.tipoDocumento && errors?.tipoDocumento)}
										/>
									</Col>
								</Row>
							)}

							<Row>
								{values?.tipoDocumento === TipoDocumenti?.CARTA_IDENTITA && (
									<>
										<Col md={6}>
											<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
												<span className="fw-bold" style={{ fontSize: "20px" }}>
													Documento di identità <u>FRONTE</u>*
												</span>
												<img
													src={docIdeFront}
													style={{ width: "70px", height: "70px" }}
													className="ms-2"
												/>
											</div>
											<BftDropzone
												label=""
												idTipoDocumento={IdTipoDocumenti?.CARTA_ID_FRONT}
												idSoggetto={subjectDetails?.id}
												trascinaDocumento={IdTipoDocumentiEstesi?.CARTA_ID_FRONT}
												file={values?.DOC_IDE_FRONT}
												onChange={(e) => handleFileChange(IdTipoDocumenti?.CARTA_ID_FRONT, e)}
												isInvalid={!!(touched?.DOC_IDE_FRONT && errors?.DOC_IDE_FRONT)}
											/>
										</Col>

										<Col md={6}>
											<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
												<span className="fw-bold" style={{ fontSize: "20px" }}>
													Documento di identità <u>RETRO</u>*
												</span>
												<img
													src={docIdeRetro}
													style={{ width: "70px", height: "70px" }}
													className="ms-2"
												/>
											</div>
											<BftDropzone
												label=""
												idTipoDocumento={IdTipoDocumenti?.CARTA_ID_BACK}
												trascinaDocumento={IdTipoDocumentiEstesi?.CARTA_ID_BACK}
												idSoggetto={subjectDetails?.id}
												file={values?.DOC_IDE_BACK}
												onChange={(e) => handleFileChange(IdTipoDocumenti?.CARTA_ID_BACK, e)}
												isInvalid={!!(touched?.DOC_IDE_BACK && errors?.DOC_IDE_BACK)}
											/>
										</Col>
									</>
								)}

								{values?.tipoDocumento === TipoDocumenti?.PATENTE && (
									<>
										<Col md={6}>
											<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
												<span className="fw-bold" style={{ fontSize: "20px" }}>
													Patente <u>FRONTE</u>*
												</span>
												<img
													src={docIdeFront}
													style={{ width: "70px", height: "70px" }}
													className="ms-2"
												/>
											</div>
											<BftDropzone
												label=""
												idTipoDocumento={IdTipoDocumenti?.PATENTE_FRONT}
												trascinaDocumento={IdTipoDocumentiEstesi?.PATENTE_FRONT}
												idSoggetto={subjectDetails?.id}
												file={values?.DOC_PAT_FRONT}
												onChange={(e) => handleFileChange(IdTipoDocumenti?.PATENTE_FRONT, e)}
												isInvalid={!!(touched?.DOC_PAT_FRONT && errors?.DOC_PAT_FRONT)}
											/>
										</Col>

										<Col md={6}>
											<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
												<span className="fw-bold" style={{ fontSize: "20px" }}>
													Patente <u>RETRO</u>*
												</span>
												<img
													src={docIdeRetro}
													style={{ width: "70px", height: "70px" }}
													className="ms-2"
												/>
											</div>
											<BftDropzone
												label=""
												idTipoDocumento={IdTipoDocumenti?.PATENTE_BACK}
												trascinaDocumento={IdTipoDocumentiEstesi?.PATENTE_BACK}
												idSoggetto={subjectDetails?.id}
												file={values?.DOC_PAT_BACK}
												onChange={(e) => handleFileChange(IdTipoDocumenti?.PATENTE_BACK, e)}
												isInvalid={!!(touched?.DOC_PAT_BACK && errors?.DOC_PAT_BACK)}
											/>
										</Col>
									</>
								)}

								{values?.tipoDocumento === TipoDocumenti?.PASSAPORTO && (
									<>
										<Col md={6}>
											<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
												<span className="fw-bold" style={{ fontSize: "20px" }}>
													Passaporto <u>FRONTE</u>*
												</span>
												<img
													src={docIdeFront}
													style={{ width: "70px", height: "70px" }}
													className="ms-2"
												/>
											</div>
											<BftDropzone
												label=""
												idTipoDocumento={IdTipoDocumenti?.PASSAPORTO_FRONT}
												trascinaDocumento={IdTipoDocumentiEstesi?.PASSAPORTO_FRONT}
												idSoggetto={subjectDetails?.id}
												file={values?.DOC_PAS_FRONT}
												onChange={(e) => handleFileChange(IdTipoDocumenti?.PASSAPORTO_FRONT, e)}
												isInvalid={!!(touched?.DOC_PAS_FRONT && errors?.DOC_PAS_FRONT)}
											/>
										</Col>

										<Col md={6}>
											<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
												<span className="fw-bold" style={{ fontSize: "20px" }}>
													Passaporto <u>RETRO</u>*
												</span>
												<img
													src={docIdeRetro}
													style={{ width: "70px", height: "70px" }}
													className="ms-2"
												/>
											</div>
											<BftDropzone
												label=""
												idTipoDocumento={IdTipoDocumenti?.PASSAPORTO_BACK}
												trascinaDocumento={IdTipoDocumentiEstesi?.PASSAPORTO_BACK}
												idSoggetto={subjectDetails?.id}
												file={values?.DOC_PAS_BACK}
												onChange={(e) => handleFileChange(IdTipoDocumenti?.PASSAPORTO_BACK, e)}
												isInvalid={!!(touched?.DOC_PAS_BACK && errors?.DOC_PAS_BACK)}
											/>
										</Col>
									</>
								)}

								{!subjectDetails?.idEsponente && (
									<div className="mt-3">
										<Row>
											<Col md={6}>
												<div className="d-flex mt-4 mb-3 container d-flex justify-content-center align-items-center">
													<span className="fw-bold" style={{ fontSize: "20px" }}>
														Tessera Sanitaria <u>FRONTE</u>*
													</span>
													<img
														src={docIdeFront}
														style={{ width: "70px", height: "70px" }}
														className="ms-2"
													/>
												</div>
												<BftDropzone
													label=""
													idTipoDocumento={IdTipoDocumenti?.TESSERA_SANITARIA}
													trascinaDocumento={IdTipoDocumentiEstesi?.TESSERA_SANITARIA}
													idSoggetto={subjectDetails?.id}
													file={values?.TES_SAN}
													onChange={(e) => handleFileChange(IdTipoDocumenti?.TESSERA_SANITARIA, e)}
													isInvalid={!!(touched?.TES_SAN && errors?.TES_SAN)}
												/>
											</Col>
										</Row>
									</div>
								)}
							</Row>

							{!isReopenPath && (
								<div className="mt-5">
									<Row>
										<Col md={6}>
											<BftInput
												required
												type={"text"}
												name={"numeroDocumento"}
												placeholder={"Numero documento*"}
												value={values?.numeroDocumento?.toUpperCase()}
												onChange={(e) => {
													const { name, value } = e.target;
													setFieldValue(name, value.toUpperCase());
												}}
												isInvalid={!!errors?.numeroDocumento && touched?.numeroDocumento}
											/>
											{errors?.numeroDocumento && touched?.numeroDocumento && (
												<Form.Control.Feedback className="ms-3" type="invalid">
													{errors?.numeroDocumento}
												</Form.Control.Feedback>
											)}
										</Col>

										{values?.tipoDocumento !== TipoDocumenti?.CARTA_IDENTITA && (
											<Col md={6}>
												<div>
													<BftSelect
														name={"documentoRilasciatoDa"}
														placeholder={"Rilasciato da*"}
														value={values?.documentoRilasciatoDa}
														onChange={(e) => {
															const { name, value } = e.target;
															setFieldValue(name, value.toUpperCase());
														}}
														options={
															values?.tipoDocumento
																? ENTI_RILASCIO_DOCUMENTO[values?.tipoDocumento]
																: []
														}
														isInvalid={
															!!(touched?.documentoRilasciatoDa && errors?.documentoRilasciatoDa)
														}
													/>
												</div>
												{errors?.documentoRilasciatoDa && touched?.documentoRilasciatoDa && (
													<Form.Control.Feedback className="ms-3" type="invalid">
														{errors?.documentoRilasciatoDa}
													</Form.Control.Feedback>
												)}
											</Col>
										)}

										{values?.tipoDocumento === TipoDocumenti?.CARTA_IDENTITA && (
											<Col md={6}>
												<div>
													<BftInput
														name={"documentoRilasciatoDa"}
														placeholder={"Comune di rilascio*"}
														value={values?.documentoRilasciatoDa?.toUpperCase()}
														onChange={(e) => {
															const { name, value } = e.target;
															setFieldValue(name, value.toUpperCase());
														}}
														isInvalid={
															!!(touched?.documentoRilasciatoDa && errors?.documentoRilasciatoDa)
														}
													/>
												</div>
												{errors?.documentoRilasciatoDa && touched?.documentoRilasciatoDa && (
													<Form.Control.Feedback className="ms-3" type="invalid">
														{errors?.documentoRilasciatoDa}
													</Form.Control.Feedback>
												)}
											</Col>
										)}
									</Row>
									<div className="mx-3">
										<Row>
											<Col md={6}>
												<div className="ms-0 me-lg-3 mb-3">
													<AppDatePicker
														label="Data di rilascio*"
														name="dataRilascioDocumento"
														value={values?.dataRilascioDocumento}
														onChange={handleChangeCustom("dataRilascioDocumento", "date")}
													/>
												</div>

												{errors?.dataRilascioDocumento && touched?.dataRilascioDocumento && (
													<Form.Control.Feedback className="ms-0 mt-2" type="invalid">
														{errors?.dataRilascioDocumento}
													</Form.Control.Feedback>
												)}
											</Col>
											<Col md={6}>
												<div className="ms-0 ms-lg-3">
													<AppDatePicker
														label="Data di scadenza*"
														name="dataScadenzaDocumento"
														value={values?.dataScadenzaDocumento}
														onChange={handleChangeCustom("dataScadenzaDocumento", "date")}
													/>
												</div>

												{errors?.dataScadenzaDocumento && touched?.dataScadenzaDocumento && (
													<Form.Control.Feedback className="ms-0 mt-2 ms-lg-3" type="invalid">
														{errors?.dataScadenzaDocumento}
													</Form.Control.Feedback>
												)}
											</Col>
										</Row>
									</div>
								</div>
							)}

							<div className="mx-2 my-4">
								<BftButton type="submit" className="btn-buffetti col-12">
									Avanti
								</BftButton>
							</div>
						</form>
					);
				}}
			</Formik>

			<MessageModal
				show={showModal}
				onClose={() => setShowModal(false)}
				message={
					<div className="text-center">
						Allegare i documenti del Titolare Effettivo <br />
						<b>
							{subjectDetails?.nome} {subjectDetails?.cognome}
						</b>{" "}
						{/* <br />
						nel caso non fossero in tuo possesso puoi inviargli una mail invitandolo ad allegare i
						documenti o sospendere il processo e riprenderlo successivamente (cliccando sul bottone
						riprendi in seguito). */}
					</div>
				}
			/>
		</>
	);
};

export default VerificaIdentita;
